import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, Home } from "lucide-react";
import Seo from "@/components/Seo";
import { COMPANY } from "@/config/site";

const Merci = () => {
  const location = useLocation();
  const type = location.state?.type || "devis";

  return (
    <>
      <Seo
        title="Merci pour votre demande | ASTROLOG"
        description="Votre demande a bien été envoyée."
        noindex
      />
      <section className="flex flex-1 items-center py-24" data-testid="merci-page">
        <div className="mx-auto max-w-xl px-4 text-center">
          <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-secondary/15">
            <CheckCircle2 className="h-10 w-10 text-secondary" />
          </span>
          <h1 className="mt-6 font-heading text-3xl font-bold tracking-tight">
            {type === "devis" ? "Votre demande de devis est envoyée" : "Votre message est envoyé"}
          </h1>
          <p className="mt-4 leading-relaxed text-slate-600">
            {type === "devis"
              ? "Votre demande a bien été envoyée. Nous vous répondons sous 24 heures ouvrées avec un devis précis, gratuit et sans engagement."
              : "Votre message a bien été envoyé. Nous vous répondons sous 24 heures ouvrées."}
          </p>
          <p className="mt-3 text-sm text-slate-500">
            Une question urgente ? Appelez-nous au{" "}
            <a href={COMPANY.phoneHref} className="font-semibold text-primary hover:underline">
              {COMPANY.phone}
            </a>
            .
          </p>
          <Link
            to="/"
            data-testid="merci-home-link"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 font-heading text-sm font-semibold text-white transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-[#1D4ED8]"
          >
            <Home className="h-4 w-4" /> Retour à l'accueil
          </Link>
        </div>
      </section>
    </>
  );
};

export default Merci;
